export const getRdgoChannelCompetitorsMap = () => 
  JSON.parse(localStorage.getItem("rdgoChannelCompetitorsMap") || "{}");

export const getRdgoCompetitorsFromChannel = (channelId) => {
  if (!getRdgoChannelCompetitorsMap()) return [];
  const competitors = getRdgoChannelCompetitorsMap().find((m) => m.channel_id === channelId);
  return competitors?.competitor_brokers_var_id;
}